/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import JSZip from "jszip";
import { Box } from "@mui/system";
import { AxiosError } from "axios";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { FiTruck, FiUser } from "react-icons/fi";
import Listagem from "../../../components/listagem";
import { useAppSelector } from "../../../store/hooks";
import { confirm } from "../../../components/confirm";
import ModalForm from "../../../components/modal-form";
import { TipoFormulario } from "../../../services/constantes";
import { LocaSmartLayout } from "../../../components/locasmart-layout";
import { ehPlanoGratuito, estaEmPeriodoDeTeste, obterIdTenent, usuarioTemAlgumaPermissao } from "../../../services/seguranca";
import { useFiliais } from "../../../hooks/useFiliais";
import { converterStatusTrocaDeOleoParaTexto } from "../../../services/utilitarios";
import { ApiError, Campo, Opcao, StatusTrocaDeOleo, TrocaDeOleo } from "../../../services/tipos";
import { FaCarSide, FaCheckCircle, FaClipboardCheck, FaDownload, FaEdit, FaMotorcycle, FaOilCan, FaTimesCircle, FaTrash } from "react-icons/fa";

function TrocaDeOleoListagem() {
    const { empresaTemFiliais, filiaisOptions, filialSelecionada, getCampoFilial, getAcaoEmLoteFilial, labelComFilial } = useFiliais();
    const [isMobile] = useState(window.innerWidth <= 768);
    const [locacoes, setLocacoes] = useState<Opcao[]>([]);
    const [locacoesRaw, setLocacoesRaw] = useState<any[]>([]);
    const [filialNoForm, setFilialNoForm] = useState<string | null>(null);
    const [locacaoVeiculoMap, setLocacaoVeiculoMap] = useState<Record<string, { idVeiculo: string; placa: string }>>({});
    const [fezAlgumaAcao, setFezAlgumaAcao] = useState(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [trocasDeOleo, setTrocasDeOleo] = useState<TrocaDeOleo[]>([]);
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [carregandoSelect, setCarregandoSelect] = useState<boolean>(false);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [entidadeParaAtualizarNoModal, setEntidadeParaAtualizarNoModal] = useState<any>({});
    const [trocaDeOleoSelecionado, setTrocaDeOleoSelecionado] = useState<TrocaDeOleo>({} as TrocaDeOleo);
    const [forcarAtualizacaoDeEntidadeNoModal, setForcarAtualizacaoDeEntidadeNoModal] = useState<boolean>(false);
    const [dataEnvio, setDataEnvio] = useState<Date>(new Date());

    const colunas = [
        {
            field: 'locacao',
            headerName: 'Locação',
            flex: 2,
            sortable: false,
            filterable: false,
            renderCell: (params: any) => {
                const { locatario, veiculo } = params.row.locacao;

                const getVehicleIcon = () => {
                    switch (Number(veiculo.tipoVeiculo)) {
                        case 1: return <FaCarSide size={16} />;
                        case 2: return <FaMotorcycle size={16} />;
                        case 3: return <FiTruck size={16} />;
                        default: return <FaCarSide size={16} />;
                    }
                };

                const veiculoLabel = `${veiculo.placa}: ${veiculo.marca} ${veiculo.modelo}`;

                return (
                    <Box display="flex" flexDirection="column" py={0.5}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <FiUser size={16} />
                            <Typography variant="body2">{locatario.nome}</Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                            {getVehicleIcon()}
                            <Typography variant="body2">{veiculoLabel}</Typography>
                        </Box>
                    </Box>
                );
            }
        },
        {
            field: 'hodometro',
            headerName: 'Hodômetro',
            flex: 1,
            sortable: false,
            filterable: false,
        },
        {
            field: 'data',
            headerName: 'Data',
            flex: 0.7,
            valueGetter: (params: any) => new Date(params.value),
            renderCell: renderData
        },
        {
            field: 'obs',
            headerName: 'Observação',
            flex: 1.5,
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1.5, renderCell: (params: any) => {
                const status = params.value;
                const statusText = converterStatusTrocaDeOleoParaTexto(status);

                let backgroundColor;
                if (status === StatusTrocaDeOleo.Aprovada) backgroundColor = '#4CAF50';
                else if (status === StatusTrocaDeOleo.EmAnalise) backgroundColor = '#FFC107'
                else if (status == StatusTrocaDeOleo.FeitoPeloLocador) backgroundColor = '#2196F3'
                else backgroundColor = '#f44336';

                return (
                    <span style={{
                        backgroundColor,
                        color: 'white',
                        padding: '5px 10px',
                        borderRadius: '5px',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }}>
                        {statusText}
                    </span>
                );
            }
        },
        ...(empresaTemFiliais ? [{
            field: 'idFilial', headerName: 'Unidade', flex: 1,
            renderCell: (params: any) => {
                if (!params.value) return '';
                const filial = filiaisOptions.find((f: any) => f.valor === params.value);
                return filial?.label || '';
            }
        }] : []),
    ];

    function renderData(params: any) {
        const diasDaSemana = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return '';

        const diaSemana = diasDaSemana[date.getDay()];
        const dataFormatada = date.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });

        const horaFormatada = date.toLocaleTimeString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });

        const resetHora = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

        const hoje = resetHora(new Date());
        const comparada = resetHora(date);

        let textoExtra = `(${diaSemana})`;

        const diffMs = comparada.getTime() - hoje.getTime();
        const diffDias = diffMs / (1000 * 60 * 60 * 24);

        if (diffDias === -1) textoExtra = "(Ontem)";
        else if (diffDias === 0) textoExtra = "(Hoje)";
        else if (diffDias === 1) textoExtra = "(Amanhã)";
        else textoExtra = `(${diaSemana})`;

        return (
            <Box display="flex" flexDirection="column" lineHeight={1.2} alignItems={isMobile ? "start" : "center"}>
                <span>{dataFormatada} {horaFormatada}</span>
                <span style={{ fontSize: '13px', color: '#888' }}>{textoExtra}</span>
            </Box>
        );
    }

    // Filtra locações pelo filial selecionado no formulário
    const locacoesFiltradas = filialNoForm
        ? locacoesRaw.filter((l: any) => !l.idFilial || l.idFilial === filialNoForm).map((l: any) => ({
            codigo: l.id, valor: l.id,
            label: labelComFilial(`${l.veiculo.placa} - ${l.locatario.nome}`, l.idFilial),
        }))
        : locacoes;

    const campos: Campo[] = [
        { label: 'Locação', nome: 'idLocacao', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 1, visible: true, opcoes: locacoesFiltradas, carregando: carregandoSelect, apenasLeitura: true },
        { label: 'Hodômetro', nome: 'hodometro', required: false, tipo: 'number', largura: 6, coluna: 1, linha: 2, visible: true, },
        { label: 'Data de Envio', nome: 'data', required: false, tipo: 'datetime-local', largura: 6, coluna: 1, linha: 2, visible: true, },
        { label: 'Observação', nome: 'obs', required: true, tipo: 'memo', largura: 12, coluna: 1, linha: 3, visible: true, },
        { label: 'Foto do Painel', nome: 'fotoPainel', required: false, tipo: 'photo', largura: 6, coluna: 2, linha: 2, visible: true, },
        { label: 'Foto do Óleo', nome: 'fotoDoOleo', required: false, tipo: 'photo', largura: 6, coluna: 2, linha: 2, visible: true, },
        { label: 'Foto do Recibo', nome: 'fotoDoRecibo', required: false, tipo: 'photo', largura: 6, coluna: 2, linha: 2, visible: true, },
        { label: 'Vídeo da Troca', nome: 'videoDaTroca', required: false, tipo: 'video', largura: 6, coluna: 2, linha: 2, visible: true, },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 4, visible: false, },
        ...(getCampoFilial({ linha: 5, onCampoDigitar: (idFilial: string) => setFilialNoForm(idFilial || null) }) ? [getCampoFilial({ linha: 5, onCampoDigitar: (idFilial: string) => setFilialNoForm(idFilial || null) })!] : []),
    ];

    const camposCadastro: Campo[] = [
        {
            label: 'Locação', nome: 'idLocacao', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 1, visible: true, opcoes: locacoesFiltradas, carregando: carregandoSelect, apenasLeitura: false,
            onCampoDigitar: (e: any) => {
                if (e) {
                    const label = locacoes.find(l => l.valor === e)?.label || '';
                    const placa = label.split(' - ')[0].trim();
                    if (placa) {
                        api.get(`/AzulMonitor/Odometro/${obterIdTenent(token)}/${placa.replace('-', '').toUpperCase()}`)
                            .then(res => {
                                if (res.data?.encontrado) {
                                    setEntidadeParaAtualizarNoModal({ hodometro: Math.round(res.data.odometroKm) });
                                    setForcarAtualizacaoDeEntidadeNoModal(true);
                                }
                            })
                            .catch(() => {});
                    }
                }
            },
        },
        { label: 'Hodômetro da Troca', nome: 'hodometro', required: false, tipo: 'number', largura: 6, coluna: 1, linha: 2, visible: true, },
        { label: 'Data da Troca', nome: 'data', required: false, tipo: 'datetime-local', largura: 6, coluna: 1, linha: 2, visible: true, },
        { label: 'Observação', nome: 'obs', required: true, tipo: 'memo', largura: 12, coluna: 1, linha: 3, visible: true, },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 4, visible: false, },
        ...(getCampoFilial({ linha: 5, onCampoDigitar: (idFilial: string) => setFilialNoForm(idFilial || null) }) ? [getCampoFilial({ linha: 5, onCampoDigitar: (idFilial: string) => setFilialNoForm(idFilial || null) })!] : []),
    ];

    const pages = [
        {
            titulo: "Informações",
            campos: ["idLocacao", "hodometro", "data", "obs", "idFilial"]
        },
        {
            titulo: "Foto do Painel",
            campos: ["fotoPainel"]
        },
        {
            titulo: "Foto do óleo",
            campos: ["fotoDoOleo"]
        },
        {
            titulo: "Recibo",
            campos: ["fotoDoRecibo"]
        },
        {
            titulo: "Vídeo da Troca",
            campos: ["videoDaTroca"]
        },
    ];


    useEffect(() => {
        const fetchLocacoes = async () => {
            setCarregandoSelect(true);
            try {
                const response = await api.get(`/LocacaoPorEmpresaSemPaginacao/${obterIdTenent(token)}`);
                const novasOpcoes = response.data.map((locacao: any) => ({
                    codigo: locacao.id,
                    valor: locacao.id,
                    label: labelComFilial(`${locacao.veiculo.placa} - ${locacao.locatario.nome}`, locacao.idFilial),
                }));
                setLocacoes(novasOpcoes);
                setLocacoesRaw(response.data);

                const veiculoMap: Record<string, { idVeiculo: string; placa: string }> = {};
                response.data.forEach((locacao: any) => {
                    veiculoMap[locacao.id] = { idVeiculo: locacao.veiculo?.id || locacao.idVeiculo, placa: locacao.veiculo?.placa || '' };
                });
                setLocacaoVeiculoMap(veiculoMap);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            } finally {
                setCarregandoSelect(false);
            }
        }

        fetchLocacoes();
    }, [exibirFormModal])

    const temPermissao = usuarioTemAlgumaPermissao(token, ['trocadeoleo_visualizar']);

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeNoModal) {
            setForcarAtualizacaoDeEntidadeNoModal(false);
        }
    }, [forcarAtualizacaoDeEntidadeNoModal]);

    const tratarErro = (error: AxiosError<ApiError>) => {
        setCarregando(false);
        setIsSubmiting(false);
        const errorMessage = error.response?.data?.Mensagem || 'Erro desconhecido';
        toast.error(`Não foi possível continuar a operação TrocaDeOleo: ${errorMessage}`);
    }

    const handleFecharModal = () => {
        setExibirFormModal(false);
        if ((modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) && fezAlgumaAcao) {
            setRealizarConsulta(true);
            setFezAlgumaAcao(false);
        }
    }

    const handleExclusao = (trocaDeOleo: TrocaDeOleo) => {
        if (usuarioTemAlgumaPermissao(token, ['trocadeoleo_excluir'])) {
            setCarregando(true);
            api.delete(`/TrocaDeOleo/${trocaDeOleo.id}`)
                .then(response => {
                    setTimeout(() => {
                        toast.success('Troca de Óleo foi excluída com sucesso');
                        setRealizarConsulta(true)
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error);
                });
        }
    };

    const handleVisualizacao = async (trocaDeOleo: any) => {
        if (usuarioTemAlgumaPermissao(token, ['trocadeoleo_visualizar'])) {
            setTrocaDeOleoSelecionado(trocaDeOleo);
            setExibirFormModal(true);
            setModo(TipoFormulario.tpVisualizacao);
        }
    };

    useEffect(() => {
        if (trocaDeOleoSelecionado) {
            setDataEnvio(new Date(trocaDeOleoSelecionado.data));
        }
    }, [trocaDeOleoSelecionado])

    useEffect(() => {
        const fetchData = async () => {
            if (temPermissao && realizarConsulta) {
                setCarregando(true);
                try {
                    const response = await api.get(`/TrocaDeOleo/PorEmpresa/${obterIdTenent(token)}`);
                    setTrocasDeOleo(response.data);
                } catch (error) {
                    tratarErro(error as AxiosError<ApiError>);
                } finally {
                    setCarregando(false);
                    setRealizarConsulta(false);
                }
            }
        };

        fetchData();
    }, [temPermissao, realizarConsulta, token]);

    const requisicaoBemSucedida = (aprovada: boolean) => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        setFezAlgumaAcao(true);
        setCarregando(false)
        setIsSubmiting(false)
        if (aprovada) {
            toast.success('Troca de Óleo salva com sucesso. O locatário agora poderá transmitir outra troca', { autoClose: 8000 });
            toast.info('Atenção: Armazenamos apenas as 3 últimas trocas de óleo. As anteriores são removidas automaticamente. Para salvar algum arquivo, clique no ícone de download.', { autoClose: 12000 });
        } else {
            toast.success('Troca de Óleo recusada com sucesso. O locatário agora poderá transmitir outra troca', { autoClose: 8000 });
            toast.info('Atenção: Armazenamos apenas as 3 últimas trocas de óleo. As anteriores são removidas automaticamente. Para salvar algum arquivo, clique no ícone de download.', { autoClose: 12000 });
        }
    }

    const aprovarOuRecusarTrocaDeOleo = async (aprovar: boolean, entidade?: any) => {
        if (entidade.status == StatusTrocaDeOleo.FeitoPeloLocador) {
            toast.info('Essa troca foi criada diretamente pelo locador. Dessa forma, não tem a opção de aprovar ou recusar!');
            return;
        }
        const trocaDeOleo = entidade || trocaDeOleoSelecionado;
        if (trocaDeOleo) {
            setIsSubmiting(true);
            api.put(`/TrocaDeOleo/AtualizarStatus/${trocaDeOleo.id}/${aprovar ? StatusTrocaDeOleo.Aprovada : StatusTrocaDeOleo.Recusada}`).then(async () => {
                requisicaoBemSucedida(aprovar);
                setIsSubmiting(false);

                // Ao aprovar, verificar plano de troca de óleo
                if (aprovar && trocaDeOleo.idVeiculo) {
                    await verificarPlanoTrocaDeOleo(trocaDeOleo.idVeiculo, Number(trocaDeOleo.hodometro) || 0);
                }
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
        }

        if (await confirm("Deseja baixar os arquivos desta troca de óleo?", { waitSeconds: 5 })) {
            handleDownload(trocaDeOleo);
        }
    }
    const handleDownload = async (entidade: any) => {
        if (entidade.status == StatusTrocaDeOleo.FeitoPeloLocador) {
            toast.info('Essa troca foi criada diretamente pelo locador. Dessa forma, não tem a opção de baixar imagens e vídeo!');
            return;
        }

        const arquivos = [
            { nome: "fotoPainel.jpg", url: entidade.fotoPainel },
            { nome: "fotoDoOleo.jpg", url: entidade.fotoDoOleo },
            { nome: "fotoDoRecibo.jpg", url: entidade.fotoDoRecibo },
            { nome: "videoDaTroca.mp4", url: entidade.videoDaTroca },
        ].filter(a => a.url);

        if (arquivos.length === 0) {
            toast.info('Não é possível baixar pois os arquivos já foram excluídos. Lembrando que só mantemos as 3 últimas trocas de óleo do veículo.');
            return;
        }

        const zip = new JSZip();

        for (const arquivo of arquivos) {
            try {
                const response = await fetch(arquivo.url);
                const blob = await response.blob();
                zip.file(arquivo.nome, blob);
            } catch (err: any) {
                tratarErro(err);
            }
        }

        const conteudo = await zip.generateAsync({ type: "blob" });
        const nomeArquivo = `troca_de_oleo_${entidade.locacao.locatario.nome}-${entidade.locacao.veiculo.placa}.zip`;

        toast.info('Iniciando download dos arquivos');
        saveAs(conteudo, nomeArquivo);
        toast.success('Arquivos da troca de óleo baixados com sucesso!', { autoClose: 8000 });
    };

    const verificarPlanoTrocaDeOleo = async (idVeiculo: string, hodometro: number) => {
        if (!idVeiculo) return;
        try {
            // Verificar se existe plano de troca de óleo ativo
            const planoRes = await api.get(`/PlanoManutencao/TrocaDeOleoAtivo/${idVeiculo}`);
            if (planoRes.status === 200 && planoRes.data) {
                const placa = planoRes.data.veiculo?.placa || '';
                if (await confirm(`O veículo ${placa} possui um plano de troca de óleo ativo. Deseja marcar como feito?`)) {
                    await api.post('/PlanoManutencao/MarcarTrocaDeOleoComoFeito', { idVeiculo, hodometro });
                    toast.success('Plano de troca de óleo atualizado!');
                }
                return;
            }
        } catch { /* 204 = sem plano */ }

        // Sem plano — verificar se veículo é rastreado para oferecer criação
        try {
            // Buscar placa a partir do mapa de locações
            const veiculoInfo = Object.values(locacaoVeiculoMap).find(v => v.idVeiculo === idVeiculo);
            if (!veiculoInfo?.placa) return;

            const statusRes = await api.post(`/AzulMonitor/VerificarPlacas/${obterIdTenent(token)}`, [veiculoInfo.placa]);
            const rastreado = statusRes.data?.some?.((s: any) => s.rastreada);
            if (!rastreado) return;

            if (await confirm(`Deseja criar um plano de troca de óleo para acompanhar automaticamente a próxima troca deste veículo?`)) {
                const intervalo = await promptIntervaloKm();
                if (intervalo > 0) {
                    await api.post('/PlanoManutencao/CriarPlanoTrocaDeOleo', {
                        idEmpresa: obterIdTenent(token), idVeiculo, hodometro, intervaloKm: intervalo
                    });
                    toast.success('Plano de troca de óleo criado com sucesso!');
                }
            }
        } catch { /* rastreador não configurado */ }
    };

    const promptIntervaloKm = (): Promise<number> => {
        return new Promise((resolve) => {
            const modal = document.createElement('div');
            modal.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.5);z-index:99999;display:flex;align-items:center;justify-content:center;';
            const box = document.createElement('div');
            box.style.cssText = 'background:white;border-radius:12px;padding:28px;width:90%;max-width:400px;';
            box.innerHTML = `
                <h3 style="margin:0 0 8px 0;color:#1F467E;font-size:16px;">Intervalo de Troca de Óleo</h3>
                <p style="margin:0 0 16px 0;color:#666;font-size:13px;">A cada quantos km o óleo deve ser trocado?</p>
                <input id="intervalo-km" type="number" value="5000" style="width:100%;padding:10px;border:1px solid #ddd;border-radius:6px;margin-bottom:16px;font-size:14px;box-sizing:border-box;" />
                <div style="display:flex;gap:10px;justify-content:flex-end;">
                    <button id="btn-cancelar" style="padding:10px 20px;border:1px solid #ddd;border-radius:8px;cursor:pointer;background:#f8f9fa;font-size:14px;">Cancelar</button>
                    <button id="btn-confirmar" style="padding:10px 20px;border:none;border-radius:8px;cursor:pointer;background:#1F467E;color:white;font-weight:600;font-size:14px;">Confirmar</button>
                </div>
            `;
            modal.appendChild(box);
            document.body.appendChild(modal);

            const input = box.querySelector('#intervalo-km') as HTMLInputElement;
            input?.focus();
            input?.select();

            const cleanup = () => document.body.removeChild(modal);
            box.querySelector('#btn-cancelar')?.addEventListener('click', () => { cleanup(); resolve(0); });
            box.querySelector('#btn-confirmar')?.addEventListener('click', () => { cleanup(); resolve(Number(input?.value) || 0); });
            modal.addEventListener('click', (e) => { if (e.target === modal) { cleanup(); resolve(0); } });
            input?.addEventListener('keydown', (e) => { if (e.key === 'Enter') { cleanup(); resolve(Number(input?.value) || 0); } });
        });
    };

    const handleRegistrarTrocaDeOleo = async (entidade: any) => {
        setIsSubmiting(true);

        const formData = new FormData();

        const fileFields = ['fotoPainel', 'fotoDoOleo', 'fotoDoRecibo', 'videoDaTroca'];
        Object.keys(entidade).forEach(key => {
            if (entidade[key] !== null && entidade[key] !== undefined) {
                if (key !== 'id' && !fileFields.includes(key)) {
                    formData.append(key, entidade[key]);
                }
            }
        });

        fileFields.forEach(field => {
            if (entidade[field]) formData.append(field, entidade[field]);
        });

        formData.append("status", StatusTrocaDeOleo.FeitoPeloLocador.toString());
        formData.append("idEmpresa", obterIdTenent(token));
        if (entidade.idFilial) formData.append("idFilial", entidade.idFilial);

        api.post('/TrocaDeOleo/', formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then(async (response) => {
            toast.success('Troca de óleo registrada com sucesso');
            setRealizarConsulta(true);
            setExibirFormModal(false);
            setFezAlgumaAcao(true);
            setCarregando(false);
            setIsSubmiting(false);

            // Verificar plano de troca de óleo
            const veiculoInfo = locacaoVeiculoMap[entidade.idLocacao];
            if (veiculoInfo) {
                await verificarPlanoTrocaDeOleo(veiculoInfo.idVeiculo, Number(entidade.hodometro) || 0);
            }
        }).catch((error: AxiosError<ApiError>) => {
            tratarErro(error);
        });
    };

    const handleEditarTrocaDeOleo = async (entidade: any) => {
        setIsSubmiting(true);

        const formData = new FormData();

        const fileFields = ['fotoPainel', 'fotoDoOleo', 'fotoDoRecibo', 'videoDaTroca'];
        Object.keys(entidade).forEach(key => {
            if (entidade[key] !== null && entidade[key] !== undefined) {
                if (!fileFields.includes(key)) {
                    formData.append(key, entidade[key]);
                }
            }
        });

        fileFields.forEach(field => {
            if (entidade[field]) formData.append(field, entidade[field]);
        });

        formData.append("status", StatusTrocaDeOleo.FeitoPeloLocador.toString());
        formData.append("idEmpresa", obterIdTenent(token));
        if (entidade.idFilial) formData.append("idFilial", entidade.idFilial);

        api.put('/TrocaDeOleo/', formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then(response => {
            setTimeout(() => {
                toast.success('Troca de óleo registrada com sucesso');
                setRealizarConsulta(true);
                setExibirFormModal(false);
                setFezAlgumaAcao(true);
                setCarregando(false);
                setIsSubmiting(false);
            }, 250);
        }).catch((error: AxiosError<ApiError>) => {
            tratarErro(error);
        });
    };


    const getCamposParaModal = () => {
        if (trocaDeOleoSelecionado?.status === StatusTrocaDeOleo.FeitoPeloLocador) {
            return camposCadastro;
        }

        if (modo === TipoFormulario.tpCadastro) {
            return camposCadastro;
        }

        return campos;
    };

    return (
        <>
            <LocaSmartLayout>
                <Listagem
                    permissoes={{ editar: ['trocadeoleo_editar'], excluir: ['trocadeoleo_excluir'] }}
                    colunas={colunas}
                    linhas={trocasDeOleo}
                    nomeEntidade="Troca de óleo"
                    nomePropriedade="obs"
                    carregando={carregando}
                    IconeEntidade={FaOilCan}
                    exibirAcoesDeCrud={false}
                    acoesExtras={[{
                        Icone: FaEdit, OnClick(entidade) {
                            if (entidade.status == StatusTrocaDeOleo.Aprovada || entidade.status == StatusTrocaDeOleo.Recusada) {
                                setExibirFormModal(false);
                                toast.info('A troca de óleo já foi analisada anteriormente.');
                                return;
                            }

                            setTrocaDeOleoSelecionado(entidade);
                            setModo(TipoFormulario.tpEdicao);
                            setExibirFormModal(true);
                        },
                        Texto: "Analisar", Tamanho: "medium",
                    }, {
                        Icone: FaTrash, OnClick(entidade) {
                            handleExclusao(entidade);
                        },
                        Texto: "Excluir", Tamanho: "medium",
                    }, {
                        Icone: FaDownload, OnClick(entidade) {
                            handleDownload(entidade);
                        },
                        Texto: "Baixa arquivos", Tamanho: "medium",
                    }, {
                        Icone: FaCheckCircle, OnClick(entidade) {
                            aprovarOuRecusarTrocaDeOleo(true, entidade);
                        },
                        Texto: "Aprovar Troca de óleo", Tamanho: "medium",
                    },
                    {
                        Icone: FaTimesCircle, OnClick(entidade) {
                            aprovarOuRecusarTrocaDeOleo(false, entidade);
                        },
                        Texto: "Recusar Troca de óleo", Tamanho: "medium",
                    }]}
                    handleEditar={() => { }}
                    handleCriar={() => {
                        setTrocaDeOleoSelecionado({} as TrocaDeOleo);
                        setModo(TipoFormulario.tpCadastro);
                        setExibirFormModal(true);
                    }}
                    handleExclusao={handleExclusao}
                    handleVisualizacao={handleVisualizacao}
                    handleSelecionarEntidade={setTrocaDeOleoSelecionado}
                    acoesEmLote={[
                        ...(getAcaoEmLoteFilial('TrocaDeOleo', () => setRealizarConsulta(true)) ? [getAcaoEmLoteFilial('TrocaDeOleo', () => setRealizarConsulta(true))!] : []),
                    ]}
                />

                <ModalForm
                    modo={modo}
                    tamanho="lg"
                    corBotaoOk={modo == TipoFormulario.tpCadastro ? undefined : "#4CAF50"}
                    footerText={modo == TipoFormulario.tpCadastro ? [] : trocaDeOleoSelecionado.status == StatusTrocaDeOleo.FeitoPeloLocador ? [{ text: 'Essa troca de óleo não foi enviada pelo locatário', color: '#1F467E' }] : [{ text: dataEnvio ? `Data de envio: ${dataEnvio.toLocaleString('pt-BR')}` : '' }]}
                    campos={getCamposParaModal()}
                    onSave={async (entidade: any) => {
                        if (modo == TipoFormulario.tpCadastro) {
                            await handleRegistrarTrocaDeOleo(entidade);
                        } else {
                            if (trocaDeOleoSelecionado && trocaDeOleoSelecionado.status == StatusTrocaDeOleo.FeitoPeloLocador) {
                                handleEditarTrocaDeOleo(entidade)
                            } else {
                                await aprovarOuRecusarTrocaDeOleo(true, entidade);
                            }
                        }
                    }}
                    show={exibirFormModal}
                    isSaving={isSubmiting}
                    carregando={carregando}
                    planoPremium={!ehPlanoGratuito(token) && !estaEmPeriodoDeTeste(token)}
                    habilitarBotaoOkEmVisualizacao
                    tituloBotaoOk={modo == TipoFormulario.tpCadastro ? 'Registrar' : trocaDeOleoSelecionado && trocaDeOleoSelecionado.status == StatusTrocaDeOleo.FeitoPeloLocador ? 'Salvar' : "Aprovar"}
                    botaoExtra={modo !== TipoFormulario.tpCadastro && trocaDeOleoSelecionado?.status !== StatusTrocaDeOleo.FeitoPeloLocador ? {
                        cor: "#f44336", titulo: "Reprovar", onClick: async (entidade) => {
                            await aprovarOuRecusarTrocaDeOleo(false, entidade);
                        },
                    } : undefined}
                    titulo={modo == TipoFormulario.tpCadastro ? "Registrando Troca de óleo" : "Conferência de Troca de óleo"}

                    onHide={handleFecharModal}
                    onCancel={handleFecharModal}
                    pages={modo == TipoFormulario.tpCadastro || trocaDeOleoSelecionado?.status === StatusTrocaDeOleo.FeitoPeloLocador ? undefined : pages}
                    ajudinha={
                        {
                            texto: "Aqui, você poderá acompanhar as trocas de óleo informadas pelo seu locatário através do nosso APP. Caso queira, também é possível registrar uma troca de óleo manualmente",
                            autoCloseTime: 3,
                            ehDestacado: true
                        }
                    }
                    entidadeSelecionada={trocaDeOleoSelecionado}
                    apiConfig={
                        {
                            endpoint: "TrocaDeOleo",
                            requisicaoBemSucedida: requisicaoBemSucedida,
                            tratarErro: tratarErro,
                            idTenentCampo: 'idEmpresa'
                        }
                    }
                    atualizacaoEntidade={
                        {
                            entidadeUsadaParaAtualizacao: entidadeParaAtualizarNoModal,
                            forcarAtualizacao: forcarAtualizacaoDeEntidadeNoModal
                        }
                    }
                />
            </LocaSmartLayout>
        </>
    );
}

export default TrocaDeOleoListagem;